import { ClientJS } from "clientjs";
import Cookies from 'universal-cookie';

const QueryString = function () {
    // This function is anonymous, is executed immediately and
    // the return value is assigned to QueryString!
    const query_string = {};
    const query = window.location.search.substring(1);
    const vars = query.split("&");
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        // If first entry with this name
        if (typeof query_string[pair[0]] === "undefined") {
            query_string[pair[0]] = decodeURIComponent(pair[1]);
        }
    }
    return query_string;
}();

const cookies = new Cookies();

if (QueryString.hasOwnProperty('refcode') || QueryString.hasOwnProperty('r') || QueryString.hasOwnProperty('af_sub4')) {
    const refcode = cookies.get('refcode');
    if (!refcode) {
        cookies.set('refcode', (QueryString.refcode || QueryString.r || QueryString.af_sub4), {
            path: '/',
            maxAge: 60 * 60 * 24 * 365
        });
    }
}

toCookie('app_id', { refreshCookie: true });
toCookie('app_instance_id', { refreshCookie: true });
toCookie('app_version', { refreshCookie: true });
// toCookie('coupon', { refreshCookie: true });

const client = new ClientJS();
// @ts-ignore
const browser = client.getBrowserData();
cookies.set('br', browser, { path: '/' });
cookies.set('referrer', document.referrer, { path: '/', maxAge: 60 * 60 * 24 * 7 });

function toCookie(param, options = {}) {
    const {
        cookieName = param,
        maxAge = 60 * 60 * 24 * 365,
        refreshCookie = false,
    } = options;
    if (QueryString.hasOwnProperty(param)) {
        const value = cookies.get(cookieName);
        if (value === undefined || refreshCookie) {
            cookies.set(cookieName, QueryString[param], { path: '/', maxAge: maxAge });
        }
    }
}
